/**
 * SSR utilities for widget
 * Widget runs client-side only, but needs domain detection
 */

export const isSSR = typeof window === 'undefined'

export const isDevEnv =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('dev') ||
    window.location.hostname.includes('staging'))

export const isLocalEnv = typeof window !== 'undefined' && window.location.hostname === 'localhost'

/**
 * Determines the base domain for API calls.
 * For widget, uses window.location.origin
 */
export const getDomainWebsite = (): string => {
  if (typeof window === 'undefined') {
    return ''
  }

  return window.location.origin
}
